import React from 'react'
import { Row } from 'antd'
import { BigSale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import styles from './SaleInvoiceDetails.module.scss'
import { CustomLink, CustomAlert, CustomCol, CustomTitle } from 'src/components'
import { getCTFeesInvoice, getFormatedPrice, getSaleVatInvoice } from 'src/core/helpers'

const SaleInvoicesDetails: React.FC<{ sale: BigSale }> = ({ sale }) => {
  const { t } = useTranslation()
  const hasNoInvoices = !sale.invoiceP2p && !sale.invoiceFeeSeller

  const links = [
    {
      label: t('Transactions.Transaction'),
      link: getSaleVatInvoice(sale),
      isDisabled: !sale.invoiceP2p,
      priceLabel: getFormatedPrice(+sale.projectCurrencyTotalTransaction, sale.projectCurrencyCode),
      show: sale.invoiceP2p
    },
    {
      label: t('Transactions.VAT'),
      link: getSaleVatInvoice(sale),
      isDisabled: !sale.projectCurrencyVatAmount,
      show: +sale.projectCurrencyVatAmount > 0,
      priceLabel: getFormatedPrice(+sale.projectCurrencyVatAmount, sale.projectCurrencyCode),
    },
    {
      label: t('Transactions.CTFees'),
      link: getCTFeesInvoice(sale),
      isDisabled: !sale.invoiceFeeSeller,
      priceLabel: `- ${getFormatedPrice(
        +sale.invoiceFeeSellerBaseAmount +
        +sale.invoiceFeeSellerTaxAmount,
        sale.projectCurrencyCode)}
        `,
      show: sale.invoiceFeeSeller
    }
  ]

  return <>
    {sale.supplierInvoice ? null : (hasNoInvoices ? <div className='centered-div'>
      <CustomAlert
        message={t('Transactions.NoInvoices')}
        type='info'
      />
    </div> : <>
      <CustomTitle label={t('Transactions.FeeDetails')} type={null} />
      {links.map((link, idx) => <div key={idx}>
        {link.show && <Row key={idx}>
          <CustomCol xs={12}>
            <CustomLink
              label={link.label}
              link={link.link}
              isDisabled={link.isDisabled}
            />
          </CustomCol>
          <CustomCol xs={12} className={styles.texts}>
            <CustomTitle label={link.priceLabel} type={null} />
          </CustomCol>
        </Row>}
      </div>)}
    </>)}
  </>
}

export default SaleInvoicesDetails
